export const DEFAULT_PUSHER_SDK_URL = 'https://js.pusher.com/8.4/pusher.min.js';

export const PUSHER_SDK_URL = process.env.NEXT_PUBLIC_PUSHER_SDK_URL ?? DEFAULT_PUSHER_SDK_URL;

export const PUSHER_SCRIPT_SELECTOR = 'script[data-ua-pusher-sdk]';

export interface PusherChannel {
  name: string;
  bind: (eventName: string, callback: (payload: unknown) => void) => void;
  unbind_all?: () => void;
}

export interface PusherConnection {
  bind: (eventName: string, callback: (payload: unknown) => void) => void;
  state?: string;
}

export interface PusherClient {
  connection: PusherConnection;
  subscribe: (channelName: string) => PusherChannel;
  unsubscribe?: (channelName: string) => void;
  disconnect: () => void;
}

export interface PusherOptions {
  cluster: string;
  channelAuthorization?: {
    endpoint?: string;
    headersProvider?: () => Record<string, string>;
  };
}

export type PusherConstructor = new (appKey: string, options: PusherOptions) => PusherClient;

export interface PusherWindow extends Window {
  Pusher?: PusherConstructor;
  __UA_PUSHER_SDK_LOADING__?: Promise<void>;
}
